import swal from 'sweetalert2';
import { DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Pagination as LPagination, Switch as LSwitch } from '@/components/index';
import store from '@/services/store.js';
const svc = new ResourceSvc();

export default {
    name: 'AdminCourseCouponsTab',
    components: {
        LPagination,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Tag.name]: Tag,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Button,
        LSwitch
    },
    computed: {
        courseIdValue(){
            return store.getters.getCourseId;
        },
        pagedData() {
            return this.tableData.slice(this.pagination.from - 1, this.pagination.to)
        },
        queriedData() {
            var self = this;
            let result = this.tableData
            if (this.searchQuery !== '') {
                result = result.filter(function (item) {
                    return item.code.toLowerCase().indexOf(self.searchQuery.toLowerCase()) > -1;
                });
            }
            self.pagination.total = result.length
            self.pagination.from = self.getFrom();
            self.pagination.to = self.getTo();
            return result.slice(this.pagination.from - 1, this.pagination.to);
        }
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(date) {
                    return date < date.setDate(date.getDate() - 1);
                },
                shortcuts: [
                    {
                        text: 'Tomorrow', onClick(picker) { picker.$emit('pick', new Date(new Date().getTime() + 24 * 60 * 60 * 1000)); }
                    },
                    {
                        text: 'In one week',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'In two weeks',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'In one month',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'In three months',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3 * 30);
                            picker.$emit('pick', date);
                        }
                    }
                ]
            },
            pagination: {
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
                from: 0,
                to: 0,
                perPage: 5
            },
            searchQuery: '',
            propsToSearch: ['code'],
            tableColumns: [
                {
                    prop: 'code',
                    label: 'code',
                    minWidth: 150
                },
                {
                    prop: 'percentage',
                    label: 'Percentage',
                    minWidth: 80
                },
                {
                    prop: 'amount',
                    label: 'Amount',
                    minWidth: 70
                },
                {
                    prop: 'defaultMaxUsing',
                    label: 'Max Using',
                    minWidth: 70
                },
                {
                    prop: 'isActiveString',
                    label: 'Is Available',
                    minWidth: 80
                },
                {
                    prop: 'description',
                    label: 'Description',
                    minWidth: 170
                }
            ],
            tableData: [],
            activeCouponCodes:[],
            fuseSearch: null,
            isEditMode: false,
            isCreateMode: false,
            isCourseCouponEditMode: false,
            isCourseCouponCreateMode: false,

            currentId: 0,
            currentCode: '',
            currentCodeBeforeEdit: '',
            currentPercentage: null,
            currentAmount: null,
            currentIsByAmount: false,
            currentDefaultMaxUsing: null,
            currentDescription: '',
            currentIsActive: true,
            currentIsLimited: true,
            currentCourseId: 0,
            currentCourseCouponId: 0,
            currentDateExpired: null,
            currentIsExpired: null,
            currentIsAllowedForMembers: true,
            currentIsAllowedForNonMembers: true
        }
    },
    methods: {
        format_date(d) {
            var day = d.getDate();
            if ((day + '').length == 1) {
                day = '0' + day;
            }

            var month = d.getMonth() + 1;
            if ((month + '').length == 1) {
                month = '0' + month;
            }

            var hours = d.getHours();
            if ((hours + '').length == 1) {
                hours = '0' + hours;
            }

            var minutes = d.getMinutes();
            if ((minutes + '').length == 1) {
                minutes = '0' + minutes;
            }

            var seconds = d.getSeconds();
            if ((seconds + '').length == 1) {
                seconds = '0' + seconds;
            }

            var pretty_date = [d.getFullYear(), month, day].join('-');
            var pretty_time = [hours, minutes, seconds].join(':');

            return pretty_date + 'T' + pretty_time + '.000Z';
        },
        getFrom(total) {
            if (this.pagination.total == 0) {
                return 0;
            }
            return (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        },
        getTo() {
            if (this.pagination.total == 0) {
                return 0;
            }
            if ((this.pagination.currentPage) * this.pagination.perPage > this.pagination.total) {
                return this.pagination.total;
            }
            return (this.pagination.currentPage) * this.pagination.perPage;
        },
        changeCoupon() {
            var self = this;
            self.activeCouponCodes.filter(function (item) {
                if (item.id == self.currentId) {
                    self.currentCode = item.code;
                    self.currentDescription = item.description;
                    self.currentIsActive = true;

                    self.currentIsLimited = item.defaultMaxUsing != null;
                    if (self.currentIsLimited) {
                        self.currentDefaultMaxUsing = item.defaultMaxUsing
                    }
                    else {
                        self.currentDefaultMaxUsing = null;
                    }
                    

                    self.currentIsByAmount = item.percentage == null;
                    if (!self.currentIsByAmount) {
                        self.currentPercentage = item.percentage;
                        self.currentAmount = null;
                    }
                    else {
                        self.currentAmount = item.amount;
                        self.currentPercentage = null;
                    }

                    return true;
                }
                return false;
            });

        },
        countEntranceCode() {
            var self = this;
            return this.tableData.filter(function (item) {
                return item.code == self.currentCode;
            }).length;
        },
        isSaveAllowed() {
            var result = true;

            if (this.isCreateMode) {
                if (this.countEntranceCode() > 0) {
                    this.notify("This code already used. Please use another word.")
                    result = false;
                }
            }
            else
                if (this.isEditMode) {
                    if (this.currentCode != this.currentCodeBeforeEdit && this.countEntranceCode() > 0) {
                        this.notify("This code already used. Please use another word.")
                        result = false;
                    }
                }

            if (this.currentIsLimited && (this.currentDefaultMaxUsing <= 0 || this.currentDefaultMaxUsing > 999)) {
                this.notify("Default max using amount is invalid. Set value from 1, or value less than 999.")
                result = false;
            }
            if (this.currentIsExpired && (this.currentDateExpired == null || this.currentDateExpired < new Date())) {
                this.notify("Expired date has not correct value (can't be empty or in past).")
                result = false;
            }

            return result;
        },
        saveAddOrEdit() {
            if (!this.isSaveAllowed()) {
                return;
            }

            var self = this;
            var data = {
                id: self.currentId,
                code: self.currentCode,
                description: self.currentDescription,
                isActive: self.currentIsActive,
                courseId: self.courseIdValue,
                courseCouponId: self.currentCourseCouponId
            }

            if (data.isActive) {
                data.isAllowedForMembers = self.currentIsAllowedForMembers;
                data.isAllowedForNonMembers = self.currentIsAllowedForNonMembers;
            }
            else {
                data.isAllowedForMembers = false;
                data.isAllowedForNonMembers = false;
            }

            if (self.currentIsExpired) {
                data.dateExpired = self.format_date(self.currentDateExpired);
            }
            else {
                data.dateExpired = null;
            }

            if (self.currentIsLimited && self.currentDefaultMaxUsing > 0) {
                data.defaultMaxUsing = self.currentDefaultMaxUsing;
            }
            else {
                data.defaultMaxUsing = null;
            }

            if (this.currentIsByAmount) {
                data.amount = self.currentAmount;
            }
            else {
                data.percentage = self.currentPercentage;
            }

            svc.addOrUpdateCourseCouponCode(data).then(resp => {
                self.undoAnyMode();
                self.loadData();
                self.notify('Coupon code is saved', 'success', 'Success');
            }, resp => {
                //add catch
                self.undoAnyMode();
                self.notify('Coupon code was not saved. Something went wrong. Please try again...');
            });
        },
        setEditMode(index, row) {
            this.isEditMode = true;
            this.currentId = row.id;
            this.currentCourseCouponId = row.courseCouponId;
            this.currentIsActive = row.isActive;
            if (this.currentIsActive) {
                this.currentIsAllowedForMembers = row.isAllowedForMembers;
                this.currentIsAllowedForNonMembers = row.isAllowedForNonMembers;
            }
            else {
                this.currentIsAllowedForMembers = false;
                this.currentIsAllowedForNonMembers = false;
            }

            this.currentIsExpired = row.dateExpired != null;
            if (this.currentIsExpired) {
                if (Object.prototype.toString.call(row.dateExpired) === '[object Date]') {
                    this.currentDateExpired = row.dateExpired
                }
                else {
                    this.currentDateExpired = new Date(row.dateExpired)
                }
                
            }
            else {
                this.currentDateExpired = null;
            }

            this.currentCode = row.code;
            this.currentCodeBeforeEdit = row.code;
            this.currentIsActive = row.isActive;
            if (row.percentage != null) {
                this.currentPercentage = row.percentage;
                this.currentIsByAmount = false;
            }
            else {
                this.currentAmount = row.amount;
                this.currentIsByAmount = true;
            }
            
            this.currentDescription = row.description;
            this.currentIsLimited = row.defaultMaxUsing != null;
            if (this.currentIsLimited) {
                this.currentDefaultMaxUsing = row.defaultMaxUsing;
            }
            else {
                this.currentDefaultMaxUsing = null;
            }
            
        },
        setCreateMode() {
            this.isCreateMode = true;
            this.currentId = this.activeCouponCodes[0].id;
            this.currentCode = this.activeCouponCodes[0].code;
            this.currentIsActive = true;
            this.currentPercentage = this.activeCouponCodes[0].percentage;
            this.currentAmount = this.activeCouponCodes[0].amount;
            this.currentIsByAmount = this.currentAmount != null;
            this.currentDescription = this.activeCouponCodes[0].description;
            this.currentDefaultMaxUsing = this.activeCouponCodes[0].defaultMaxUsing;
            this.currentIsLimited = this.currentDefaultMaxUsing != null;
            this.currentIsAllowedForMembers = true;
            this.currentIsAllowedForNOnMembers = true;
            this.currentDateExpired = null;
            this.currentIsExpired = false;
        },
        deleteRecord(index, row) {
            var self = this;
            swal({
                title: 'Warning!',
                text: 'You really want to delete this coupon code?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(function (result) {
                if (result.value == true) {
                    self.sendDeleteCouponCode(row.id)
                }
            });
        },
        sendDeleteCouponCode(id) {
            var self = this;
            self.currentId = id;
            svc.deleteCouponCode(id).then(function (response) {
                var result = response.body;
                var message = 'Unknown result. Try to reload page';
                if (result.message) {
                    message = result.message;
                }
                if (result != true) {
                    self.$notify({
                        title: "Error while deleting!",
                        message: 'Explanation: ' + message,
                        type: 'danger'
                    });
                    return;
                }
                let indexToDelete = self.tableData.findIndex((tableRow) => tableRow.id === self.currentId);
                if (indexToDelete >= -1) {
                    self.tableData.splice(indexToDelete, 1);
                }
                this.$notify({
                    title: "Success!",
                    message: 'Coupon code has been deleted.',
                    type: 'success'
                });
            }).catch(function () { });
        },
        loadData() {
            var self = this; 
            svc.getCourseCouponCodesList(self.courseIdValue).then(function (resp) {
                var allData = resp.body;
                if (allData.isSuccess == false) {
                    window.location.reload();
                    return;
                }
                self.tableData = allData.couponCodes;
                self.pagination.total = allData.couponCodes.length;
                self.pagination.from = self.getFrom();
                self.pagination.to = self.getTo();
                self.activeCouponCodes = allData.activeCouponCodes;
            });
        },
        undoAnyMode() {
            this.isCreateMode = false;
            this.isEditMode = false;
        },
        undoAnyCourseCouponMode() {
            this.isCourseCouponCreateMode = false;
            this.isCourseCouponEditMode = false;
        },
        notify(message, type, title) {
            if (!message) {
                message = 'Something went wrong!';
            }
            if (!type) {
                type = 'danger';
            }

            if (!title) {
                title = 'Oops!'
            }
            
            this.$notify({
                title: title,
                message: message,
                type: type
            });
        }
    },
    mounted() {
    },
    created() {
        this.loadData();
    }
}






// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/course-coupons/course-coupons.js